module.exports = __webpack_public_path__ + "img/xmasParty13.9b152b79.jpg";